var image_viewer_rtlignore_default = {
  "fontElementMap": "_2eFhP",
  "imageContainer": "_76cT0",
  "expandButton": "bU7g4",
  "expandIcon": "W-PLg",
  "pointer": "vInKQ",
  "imageWrapper": "EcEJf",
  "imageRatio": "iVOij",
  "image": "lc0-v",
  "imageOverlay": "p7fj0",
  "imagePreload": "_6whXQ",
  "imageHighres": "iLcUi",
  "onlyHighRes": "MtaJX",
  "image_loading": "R4wYJ"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
